import { createTheme as createDSTheme } from 'app/shopify';

const theme = createDSTheme();

export const DONATION_BADGE_BACKGROUND_COLOR = theme.colors['surface.brand.secondary-4.default'];
